import { validate } from '@krugom/validator';
import { TValidationScheme } from '@krugom/validator/dist/types';

const redirectTo = (arg?: any) => {
  const scheme: TValidationScheme = {
    type: 'string',
    required: true,
    pattern: /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^\s/$.?#].[^\s]*$/,
  };
  const result = validate(arg, scheme);

  if (!result.isValid) return;

  window.location.href = arg;
};

export default redirectTo;
